<template>
  <!-- custom-form-common-info .cfci -->
  <div class="cfci"> 
    <div class="my-info">
      <div class="my-info-box z-half">
        <div class="my-info-box-r">日产能:</div>
        <div class="my-info-box-l">
          <Input v-model="value" style="width: 120px" /> 
        </div>
        <span>pcs</span>
      </div>
      <div class="my-info-box z-half">
        <div class="my-info-box-r">研发人数:</div>
        <div class="my-info-box-l">
          <Input v-model="value1" style="width: 120px" />  
        </div>
        <span class="my-info-txt">人</span>
      </div>
      <div class="my-info-box z-half">
        <div class="my-info-box-r">专利数:</div>
        <div class="my-info-box-l">
          <Input v-model="value2" style="width: 120px" />   
        </div>
        <span class="my-info-txt">个</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  // 领域类型 - 日产能 等详细信息
  name: "custom-form-common-info",
  props: {
    field: {
      type: Object,
      default: {List: [], TypeId: 6}
    }
  },
  model: {
    prop: "field",
    event: "sendField"
  },
  data() {
    return {
      fieldData: [], 
      popVisible: false, // 显示选择tag
      value: 0,
      value1: 0,
      value2: 0,
      myModel: {List: [], TypeId: 6}
    };
  },
  watch: {
    value(val, oldVal) { 
      this.setModel(); 
    },
    value1(val, oldVal) { 
      this.setModel(); 
    },
    value2(val, oldVal) { 
      this.setModel(); 
    }, 
  },
  async created() {
    this.init();
  },
  methods: {
    ...mapActions({}),
    init() {  
      if (this.field && this.field.List) {  
        this.field.List.forEach(c => {
          if (c.Value === '日产能') { 
            this.value = c.Remark;
          }
          if (c.Value === '研发人数') {
            this.value1 = c.Remark;
          }
          if (c.Value === '专利数') {
            this.value2 = c.Remark;
          }
        });
      }
    },
    setModel() { 
      this.myModel.List = [];
      if (this.value) {
        this.myModel.List.push({
          TypeId: -1,
          Value: "日产能",
          Remark: `${this.value}`
        });
      }
      if (this.value1) {
        this.myModel.List.push({
          TypeId: -1,
          Value: "研发人数",
          Remark: `${this.value1}`
        });
      }
      if (this.value2) {
        this.myModel.List.push({
          TypeId: -1,
          Value: "专利数",
          Remark: `${this.value2}`
        });
      }  
      this.$emit("sendField", this.myModel);
      this.$emit("refresh");
    }
  }
};
</script>

<style scope lang="scss">
.my-info {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  &-box2 {
    width: 100%;
    font-size: 14px;
    color: #333;
    display: flex;
    padding-right: 10px;
  }
  &-box {
    width: 100%;
    &.z-half {
      width: 50%;
    }
    width: 50%;
    font-size: 14px;
    color: #333;
    display: flex;
    padding-right: 10px;
    margin-bottom: 20px;
    &-l {
      flex: 1;
      font-size: 14px;
      color: #333;
    }
    &-r {
      width: 84px;
    }
  }
  &-txt {
    width: 30px;
    line-height: 32px;
    display: inline-block;
  }
}
</style>
